import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.purchase-orders.views.FranchiseePurchaseOrderView.';
  public static readonly purchaseOrderSubmitted = `${Id.prefix}purchaseOrderSubmitted`;
  public static readonly issueConfirmationQuestion = `${Id.prefix}issueConfirmationQuestion`;
  public static readonly issue = `${Id.prefix}issue`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly completeConfirmationQuestion = `${Id.prefix}completeConfirmationQuestion`;
  public static readonly yes = `${Id.prefix}yes`;
  public static readonly no = `${Id.prefix}no`;
  public static readonly cancelPurchaseOrder = `${Id.prefix}cancelPurchaseOrder`;
  public static readonly cancelIssuedPurchaseOrderWarning = `${Id.prefix}cancelIssuedPurchaseOrderWarning`;
  public static readonly cancelReasonQuestion = `${Id.prefix}cancelReasonQuestion`;
  public static readonly cancellationReason = `${Id.prefix}cancellationReason`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangFranchiseePurchaseOrderView {
  private constructor() {}
  public static purchaseOrderSubmitted(): string {
    return interpolate(Id.purchaseOrderSubmitted);
  }
  public static issueConfirmationQuestion(): string {
    return interpolate(Id.issueConfirmationQuestion);
  }
  public static issue(): string {
    return interpolate(Id.issue);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
  public static completeConfirmationQuestion(): string {
    return interpolate(Id.completeConfirmationQuestion);
  }
  public static yes(): string {
    return interpolate(Id.yes);
  }
  public static no(): string {
    return interpolate(Id.no);
  }
  public static cancelPurchaseOrder(): string {
    return interpolate(Id.cancelPurchaseOrder);
  }
  public static cancelIssuedPurchaseOrderWarning(): string {
    return interpolate(Id.cancelIssuedPurchaseOrderWarning);
  }
  public static cancelReasonQuestion(): string {
    return interpolate(Id.cancelReasonQuestion);
  }
  public static cancellationReason(): string {
    return interpolate(Id.cancellationReason);
  }
}

export class FranchiseePurchaseOrderViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderSubmitted,
      "{{glossary 'purchase-order'}} has been submitted and you will be emailed a link when the order is issued",
      'Toast message when purchase order is submitted'
    );
    register.add(
      Id.issueConfirmationQuestion,
      "Are you sure you wish to Issue the {{glossary 'purchase-order'}}?",
      'Confirmation question for issuing purchase order'
    );
    register.add(Id.issue, 'Issue', 'Button text for issuing purchase order');
    register.add(Id.cancel, 'Cancel', 'Button text for cancel');
    register.add(
      Id.completeConfirmationQuestion,
      "Are you sure you wish to Complete the {{glossary 'purchase-order'}}?",
      'Confirmation question for completing purchase order'
    );
    register.add(Id.yes, 'Yes', 'Button text for yes');
    register.add(Id.no, 'No', 'Button text for no');
    register.add(
      Id.cancelPurchaseOrder,
      "Cancel {{glossary 'purchase-order'}}",
      'Title for cancel purchase order dialog'
    );
    register.add(
      Id.cancelIssuedPurchaseOrderWarning,
      `The {{glossary 'purchase-order'}} has already been issued and cancelling can have financial implications.  
Cancelling the {{glossary 'purchase-order'}} here has no effect on the order at the {{glossary 'supplier'}}.
Contact the {{glossary 'supplier'}} to get the order cancelled.  
Do you want to Cancel the {{glossary 'purchase-order'}}?`,
      'Warning message when cancelling an already issued purchase order'
    );
    register.add(
      Id.cancelReasonQuestion,
      "Please select the reason for cancelling the {{glossary 'purchase-order'}}",
      'Prompt for cancellation reason'
    );
    register.add(Id.cancellationReason, 'Cancellation Reason', 'Label for cancellation reason input');
  }
}
